import React, { useEffect } from "react";
import Store from "./Store";
import { Helmet } from "react-helmet";
import StoryContainer from "./container/StoryContainer";
import "./App.scss";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ReactGA from "react-ga4";
import { getEnvironment, getCookieyesId, onAnalyticsConsent } from "./utils/helpers";

let country = window.location.href.indexOf("usa") != -1 ? "us" : "uk";

// ReactGA.initialize("G-9R3S0492XE");

const environment = getEnvironment();
let cookieyesId = getCookieyesId(environment);
let clarityId = country === "uk" ? "ub4b8jbk63" : "ub4bvsl1o3";

function App() {
  useEffect(() => {
    return onAnalyticsConsent(country, () => {
      if (country === "us") {
        ReactGA.initialize("G-VCC3CN6RTR");
      } else {
        ReactGA.initialize("G-5V73WL5TWH");
      }
      // Load Clarity script dynamically
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.clarity.ms/tag/${clarityId}`;

      const clarityInit = document.createElement("script");
      clarityInit.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "${clarityId}");
    `;

      document.head.appendChild(clarityInit);

      // Load Google Tag Manager dynamically
      const gtmInit = document.createElement("script");
      gtmInit.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-T838RZVG');
      `;

      document.head.appendChild(gtmInit);
    });
  }, []);

  return (
    <Store className="App">
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-T838RZVG"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
          title="Google Tag Manager"
        ></iframe>
      </noscript>
      <Helmet>
        <meta name="robots" content="noindex"></meta>
        {cookieyesId && country === "uk" && (
          <script
            id="cookieyes"
            type="text/javascript"
            src={`https://cdn-cookieyes.com/client_data/${cookieyesId}/script.js`}
          ></script>
        )}

        <script type="text/javascript" src="//script.crazyegg.com/pages/scripts/0130/4183.js" async="async"></script>
      </Helmet>
      <Router>
        <Switch>
          <Route path="/:guid">
            <StoryContainer></StoryContainer>
          </Route>
        </Switch>
      </Router>
    </Store>
  );
}

export default App;
